'use strict';

exports.__esModule = true;

var _ActionTypes = require('./ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  init: function init() {
    return {
      type: _ActionTypes2.default.INIT
    };
  },

  push: function push(location) {
    return {
      type: _ActionTypes2.default.PUSH,
      payload: location
    };
  },

  replace: function replace(location) {
    return {
      type: _ActionTypes2.default.REPLACE,
      payload: location
    };
  },

  go: function go(delta) {
    return {
      type: _ActionTypes2.default.GO,
      payload: delta
    };
  },

  dispose: function dispose() {
    return {
      type: _ActionTypes2.default.DISPOSE
    };
  }
};
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/farce/lib/Actions.js